
import { Component, ModelSync, Prop, Vue } from "vue-property-decorator";
import AddButton from "../buttons/AddButton.vue";
import CancelButton from "../buttons/CancelButton.vue";

@Component({
  components: {
    CancelButton,
    AddButton,
  },
})
export default class AddPersonDialog extends Vue {
  @ModelSync("value", "input")
  show!: boolean;

  @Prop({ default: "Benutzer hinzufügen" })
  title!: string;

  emailToAdd = "";

  isDataValid = false;

  onAdd() {
    this.show = false;
    this.$emit("add", this.emailToAdd);
  }
}
